import { Network } from '@root/entities/network'
import { DelugeId } from '@root/entities/user-short'

import { ReferralCode } from './referral-code'

import type { tradeApi } from '@blade/socket-types'
import type { OverrideKeys } from '@blade/std-lib'

export type ReferralCodeUpdateDto = Parameters<
  tradeApi.ServerToClientEvents[tradeApi.ServerEvent.ReferralCodeUpdate]
>[0]

export interface ReferralCodeUpdate
  extends OverrideKeys<
    ReferralCodeUpdateDto,
    {
      delugeId: DelugeId
      network: Network.Network
      referralCode: ReferralCode
    }
  > {}

export const fromDto = (dto: ReferralCodeUpdateDto): ReferralCodeUpdate => {
  return {
    type: dto.type,
    delugeId: DelugeId(dto.delugeId),
    referralCode: ReferralCode(dto.referralCode),
    network: Network.fromSupportedNetwork(dto.network),
  }
}
